<template>
  <div class="row" style="background-color: white;">
    <div class="col-xl-4 synops synops2">
      <div class="item">
        <span
          ><v-icon style="margin-bottom: 2px;" class="ico"
            >mdi-domain</v-icon
          ></span
        >
        <span class="company-title">{{ company_name }}</span>
      </div>
      <div class="item">
        <span><v-icon class="ico msg">mdi-star-circle</v-icon></span>
        <span>{{ plan_name }}</span>
      </div>
      <div class="item">
        <span
          ><v-icon class="ico" :color="payment_status_icon_color">{{
            payment_status_icon
          }}</v-icon></span
        >
        <span>{{ payment_status }}</span>
      </div>
      <div class="item">
        <span><v-icon class="ico ph">mdi-calendar</v-icon></span>
        <span>{{ "Expiry date: " + plan_end_date }}</span>
      </div>
    </div>
    <div class="col-xl-4 synops synops2">
      <div class="cntct-info">
        Contact Information
      </div>
      <div class="item">
        <span
          ><v-icon style="margin-bottom: 2px;" class="ico"
            >mdi-email</v-icon
          ></span
        >
        <span>{{ contact_mail }}</span>
      </div>
      <div class="item">
        <span><v-icon class="ico msg">mdi-phone</v-icon></span>
        <span>{{ contact_phone }}</span>
      </div>
    </div>
    <div class="col-xl-4">
      <div v-if="!requested" class="but">
        <v-icon
          @click="viewInvoice()"
          class="btn btn-save-new"
          style="margin-right: 1rem"
        >
          mdi-eye
        </v-icon>
        <v-icon
          @click="downloadInvoice()"
          class="btn btn-save-new"
          style="margin-right: 1rem"
        >
          mdi-download
        </v-icon>
        <v-icon @click="mailInvoice()" class="btn btn-save-new">
          mdi-email
        </v-icon>
      </div>
      <div v-if="!openPlan" class="open">
        <button
          @click="changeUpdate"
          style="width: 26rem"
          class="btn btn-next-new"
        >
          Update Plan
        </button>
      </div>
      <div v-else class="row">
        <v-select
          v-model="plan"
          style="margin-top: 3.0rem"
          solo
          outline
          label="Select A Plan*"
          :items="planItems"
          item-text="plan_name"
          item-value="plan_id"
          :error-messages="planErrors"
        ></v-select>
        <v-select
          v-model="planStatus"
          solo
          outline
          label="Plan status"
          :items="paymentStatusItems"
          item-text="text"
          item-value="value"
          :error-messages="planErrors"
        ></v-select>
        <div class="col-12 no-padding">
          <div style="text-align: left" v-if="!addDiscount">
            <button
              @click="addDiscount = true"
              v-if="!addDiscount"
              class="btn btn-save"
            >
              Add discount
            </button>
          </div>
          <div class="discount" v-else>
            <div style="width: 80%">
              <v-text-field
                v-model="discount"
                solo
                outline
                label="Discount"
                mask="##"
                suffix="%"
              ></v-text-field>
            </div>
            <v-icon class="dis-close icon-class-reject" @click="resetDiscount"
              >mdi-close-box</v-icon
            >
          </div>
        </div>
        <div style="text-align: right; margin: 2rem 0">
          <button
            style="margin-right: 1rem"
            @click="approve()"
            class="btn btn-save-new"
          >
            Update
          </button>
          <button @click="changeUpdate()" class="btn btn-cancel">
            Cancel
          </button>
        </div>
      </div>
      <div v-if="requested_plan_name" class="req-plan">
        *Requested Plan: <b>{{ requested_plan_name }}</b>
      </div>
    </div>
    <div :key="viewCount" v-if="view_key && view">
      <view-invoice v-bind:view_key="view_key"></view-invoice>
    </div>
  </div>
</template>

<script>
import ViewInvoice from "./view-invoice";
import * as FILTER from "../../../filters";
import { required } from "vuelidate/lib/validators";
import { MONTH_DATE_FORMAT } from "../../../globalFunctions";
import { INVOICE_ACTION, MAIL_INVOICE } from "../../../Api/admin_api";
export default {
  name: "job-synops",
  components: {
    ViewInvoice
  },
  props: {
    job: Object,
    plans: Array,
    index: Number,
    requested: Boolean
  },
  validations: {
    plan: { required }
  },
  data: function() {
    return {
      plan_id: null,
      company_id: null,
      company_name: null,
      plan_begin_date: null,
      plan_end_date: null,
      plan_name: null,
      payment_status: null,
      payment_status_icon: null,
      payment_status_icon_color: null,
      planItems: [],
      paymentStatusItems: [
        {
          text: "On-Request",
          value: 2
        },
        {
          text: "Paid",
          value: 3
        }
      ],
      planStatus: 2,
      generate: false,
      plan: null,
      download_key: null,
      view_key: null,
      file_name: null,
      view: false,
      viewCount: 0,
      openPlan: false,
      addDiscount: false,
      discount: null,
      requested_plan_id: null,
      requested_plan_name: null,
      contact_mail: null,
      contact_phone: null
    };
  },
  methods: {
    resetDiscount() {
      this.discount = null;
      this.addDiscount = false;
    },
    approve() {
      const self = this;
      self.$v.$touch();
      if (!self.$v.$anyError) {
        self.$emit(
          "approve-user",
          self.plan,
          self.company_id,
          self.index,
          self.discount,
          self.planStatus
        );
      } else {
        alert("Please select a plan");
      }
    },
    changeUpdate() {
      const self = this;
      self.openPlan = !self.openPlan;
    },
    viewInvoice() {
      const self = this;
      self.view = true;
      self.viewCount++;
    },
    downloadInvoice() {
      const self = this;
      let key = self.download_key;
      INVOICE_ACTION(key)
        .then(function(data) {
          const url = data.url;
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", self.file_name); //or any other extension
          document.body.appendChild(link);
          link.click();
        })
        .catch(function() {});
    },
    mailInvoice() {
      const self = this;
      MAIL_INVOICE(self.company_id)
        .then(function(res) {})
        .catch(function(err) {});
    }
  },
  computed: {
    planErrors() {
      const errors = [];
      if (!this.$v.plan.$dirty) return errors;
      !this.$v.plan.required &&
        errors.push(this.$constants.REQUIRED_MESSAGE.REQUIRED);
      return errors;
    }
  },
  mounted() {
    const self = this;
    if (self.job) {
      self.plan_id = self.job.plan_id;
      self.company_id = self.job.company_id;
      self.company_name = FILTER.FIRST_LETTER_CAPITAL(self.job.company_name);
      self.plan_begin_date = self.job.plan_begin_date;
      self.plan_end_date = MONTH_DATE_FORMAT(self.job.plan_end_date);
      self.plan_name = self.job.plan_name
        ? FILTER.FIRST_LETTER_CAPITAL(self.job.plan_name)
        : null;
      self.download_key = self.job.invoice_download_key || null;
      self.view_key = self.job.invoice_view_key || null;
      self.file_name = self.job.invoice_file_name || null;
      self.contact_mail = self.job.email || null;
      self.contact_phone = self.job.phone || null;
      if (self.job.payment_status) {
        switch (self.job.payment_status) {
          case 2:
            self.payment_status = "Payment Due";
            self.payment_status_icon = "mdi-alert-decagram";
            self.payment_status_icon_color = "#FFB823";
            self.generate = true;
            break;
          case 3:
            self.payment_status = "Paid";
            self.payment_status_icon = "mdi-check-decagram";
            self.payment_status_icon_color = "#155724";
            self.generate = false;
            break;
        }
      }
      if (self.requested) {
        if (self.job.req_plan_id) {
          self.requested_plan_id = self.job.req_plan_id;
          self.plan = self.job.req_plan_id;
          let i;
          for (i = 0; i < self.plans.length; i++) {
            if (self.plans[i].plan_id === self.job.req_plan_id) {
              self.requested_plan_name = self.plans[i].plan_name;
              break;
            }
          }
        }
      }
    }
    if (self.plans.length > 0) {
      self.planItems = self.plans.sort((a, b) =>
        parseInt(a.plan_id) > parseInt(b.plan_id) ? 1 : -1
      );
    }
  }
};
</script>

<style scoped>
.synops {
  padding: 15px;
  cursor: pointer;
  border-bottom: 1px solid #eeeeee;
}
.item {
  text-align: left;
  color: #050505;
  margin: 5px;
}
.company-title {
  font-weight: bold;
}
.ico {
  color: #506ee4;
  margin-right: 10px;
}
.msg {
  color: var(--button-color);
}
.ph {
  color: var(--button-delete-color);
}
.but {
  text-align: right;
  margin-top: 3rem;
}
.open {
  text-align: right;
  padding: 1rem 0;
}
.discount {
  position: relative;
}
.dis-close {
  position: absolute;
  top: 0;
  right: 0;
}
.cntct-info {
  text-align: left;
  padding: 0.5rem;
  font-weight: bold;
}
.req-plan {
  padding: 1rem 0;
  text-align: right;
}
</style>
